let headerFormation = {

    generalHeader: '',
    item: '',
    underContent: '',

    init: function() {
        headerFormation.generalHeader = document.getElementsByClassName('header-section')[0];
        headerFormation.item = document.getElementsByClassName('formation-header')[0];
        headerFormation.content = document.getElementsByClassName('single-content')[0];
        headerFormation.handleScroll();
        document.addEventListener('scroll', () => {
            headerFormation.handleScroll();
        })

    },

    handleScroll: function() {
        let offsetbottom = headerFormation.generalHeader.getBoundingClientRect().bottom;
        if (offsetbottom < 0) {
            headerFormation.item.classList.remove('hidden');
            headerFormation.content.classList.add('margin-top');
        } else {
            headerFormation.item.classList.add('hidden');
            headerFormation.content.classList.remove('margin-top');
        }
    }

}

document.addEventListener('DOMContentLoaded', headerFormation.init)